import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../js/coreRuntime.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../Unit.mjs';
import { EmptyIterator_instance22ozgv6vdnc2g as EmptyIterator_instance } from './CollectionsKt.mjs';
import {
  iterator3f5i676wpaa3g as iterator,
  SequenceScope1coiso86pqzq2 as SequenceScope,
} from '../sequences/SequenceBuilder.mjs';
import { AbstractIterator1svf7vpi1lw8y as AbstractIterator } from './AbstractIterator.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../js/metadataUtils.mjs';
import {
  AbstractList3ck35puwbp1e9 as AbstractList,
  Companion_instance23tt71mgnug0i as Companion_instance,
} from './AbstractList.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import { isArray1hxjqtqy632bc as isArray } from '../js/typeCheckUtils.mjs';
import {
  copyOf2ng0t8oizk6it as copyOf,
  fill3hcjvebk42tyx as fill,
} from './_ArraysJs.mjs';
import { terminateCollectionToArray12671uhv05xea as terminateCollectionToArray } from './collectionJs.mjs';
import { coerceAtMost322komnqp70ag as coerceAtMost } from '../ranges/_Ranges.mjs';
import { RandomAccess1jbw8sdogqb8x as RandomAccess } from './RandomAccess.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from './ArrayListJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function checkWindowSizeStep(size, step) {
  // Inline function 'kotlin.require' call
  if (!(size > 0 && step > 0)) {
    var message = !(size === step) ? 'Both size ' + size + ' and step ' + step + ' must be greater than zero.' : 'size ' + size + ' must be greater than zero.';
    throw IllegalArgumentException().n2(toString(message));
  }
}
function windowedIterator(iterator_0, size, step, partialWindows, reuseBuffer) {
  if (!iterator_0.q1())
    return EmptyIterator_instance;
  return iterator(windowedIterator$slambda_0(size, step, iterator_0, reuseBuffer, partialWindows));
}
var RingBuffer$iterator$1Class;
function RingBuffer$iterator$1() {
  if (RingBuffer$iterator$1Class === VOID) {
    class $ extends AbstractIterator() {
      constructor(this$0, $box) {
        if ($box === VOID)
          $box = {};
        $box.wl_1 = this$0;
        super($box);
        this.ul_1 = this$0.am_1;
        this.vl_1 = this$0.zl_1;
      }
      qi() {
        if (this.ul_1 === 0) {
          this.si();
        } else {
          this.ri(this.wl_1.xl_1[this.vl_1]);
          var tmp = this;
          var tmp0 = this.wl_1;
          // Inline function 'kotlin.collections.RingBuffer.forward' call
          tmp.vl_1 = (this.vl_1 + 1 | 0) % tmp0.yl_1 | 0;
          this.ul_1 = this.ul_1 - 1 | 0;
        }
      }
    }
    initMetadataForClass($);
    RingBuffer$iterator$1Class = $;
  }
  return RingBuffer$iterator$1Class;
}
var RingBufferClass;
function RingBuffer() {
  if (RingBufferClass === VOID) {
    class $ extends AbstractList() {
      static bm(buffer, filledSize) {
        var $this = this.xi();
        $this.xl_1 = buffer;
        // Inline function 'kotlin.require' call
        if (!(filledSize >= 0)) {
          var message = 'ring buffer filled size should not be negative but it is ' + filledSize;
          throw IllegalArgumentException().n2(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(filledSize <= $this.xl_1.length)) {
          var message_0 = 'ring buffer filled size: ' + filledSize + ' cannot be larger than the buffer size: ' + $this.xl_1.length;
          throw IllegalArgumentException().n2(toString(message_0));
        }
        $this.yl_1 = $this.xl_1.length;
        $this.zl_1 = 0;
        $this.am_1 = filledSize;
        return $this;
      }
      static cm(capacity) {
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp$ret$0 = Array(capacity);
        return this.bm(tmp$ret$0, 0);
      }
      q2() {
        return this.am_1;
      }
      r2(index) {
        Companion_instance.i7(index, this.am_1);
        // Inline function 'kotlin.collections.RingBuffer.forward' call
        var tmp$ret$0 = (this.zl_1 + index | 0) % this.yl_1 | 0;
        return this.xl_1[tmp$ret$0];
      }
      dm() {
        return this.am_1 === this.yl_1;
      }
      p1() {
        return new (RingBuffer$iterator$1())(this);
      }
      wj(array) {
        var tmp;
        if (array.length < this.am_1) {
          // Inline function 'kotlin.collections.copyOf' call
          var newSize = this.am_1;
          tmp = copyOf(array, newSize);
        } else {
          tmp = isArray(array) ? array : THROW_CCE();
        }
        var result = tmp;
        var size = this.am_1;
        var widx = 0;
        var idx = this.zl_1;
        while (widx < size && idx < this.yl_1) {
          result[widx] = this.xl_1[idx];
          widx = widx + 1 | 0;
          idx = idx + 1 | 0;
        }
        idx = 0;
        while (widx < size) {
          result[widx] = this.xl_1[idx];
          widx = widx + 1 | 0;
          idx = idx + 1 | 0;
        }
        var tmp_0 = terminateCollectionToArray(size, result);
        return isArray(tmp_0) ? tmp_0 : THROW_CCE();
      }
      i8() {
        // Inline function 'kotlin.arrayOfNulls' call
        var size = this.am_1;
        var tmp$ret$0 = Array(size);
        return this.wj(tmp$ret$0);
      }
      toArray() {
        return this.i8();
      }
      em(maxCapacity) {
        var newCapacity = coerceAtMost((this.yl_1 + (this.yl_1 >> 1) | 0) + 1 | 0, maxCapacity);
        var tmp;
        if (this.zl_1 === 0) {
          // Inline function 'kotlin.collections.copyOf' call
          var this_0 = this.xl_1;
          tmp = copyOf(this_0, newCapacity);
        } else {
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp$ret$1 = Array(newCapacity);
          tmp = this.wj(tmp$ret$1);
        }
        var newBuffer = tmp;
        return RingBuffer().bm(newBuffer, this.am_1);
      }
      fm(element) {
        if (this.dm()) {
          throw IllegalStateException().o('ring buffer is full');
        }
        // Inline function 'kotlin.collections.RingBuffer.forward' call
        var tmp$ret$0 = (this.zl_1 + this.am_1 | 0) % this.yl_1 | 0;
        this.xl_1[tmp$ret$0] = element;
        this.am_1 = this.am_1 + 1 | 0;
      }
      gm(n) {
        // Inline function 'kotlin.require' call
        if (!(n >= 0)) {
          var message = "n shouldn't be negative but it is " + n;
          throw IllegalArgumentException().n2(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(n <= this.am_1)) {
          var message_0 = "n shouldn't be greater than the buffer size: n = " + n + ', size = ' + this.am_1;
          throw IllegalArgumentException().n2(toString(message_0));
        }
        if (n > 0) {
          var start = this.zl_1;
          // Inline function 'kotlin.collections.RingBuffer.forward' call
          var end = (start + n | 0) % this.yl_1 | 0;
          if (start > end) {
            fill(this.xl_1, null, start, this.yl_1);
            fill(this.xl_1, null, 0, end);
          } else {
            fill(this.xl_1, null, start, end);
          }
          this.zl_1 = end;
          this.am_1 = this.am_1 - n | 0;
        }
      }
    }
    initMetadataForClass($, 'RingBuffer', VOID, VOID, [RandomAccess()]);
    RingBufferClass = $;
  }
  return RingBufferClass;
}
var windowedIterator$slambdaClass;
function windowedIterator$slambda() {
  if (windowedIterator$slambdaClass === VOID) {
    class $ {
      constructor($size, $step, $iterator, $reuseBuffer, $partialWindows) {
        this.hm_1 = $size;
        this.im_1 = $step;
        this.jm_1 = $iterator;
        this.km_1 = $reuseBuffer;
        this.lm_1 = $partialWindows;
      }
      *mm($this$iterator, $completion) {
        var bufferInitialCapacity = coerceAtMost(this.hm_1, 1024);
        var gap = this.im_1 - this.hm_1 | 0;
        if (gap >= 0) {
          var buffer = ArrayList().h2(bufferInitialCapacity);
          var skip = 0;
          // Inline function 'kotlin.collections.iterator' call
          var _iterator__ex2g4s = this.jm_1;
          $l$loop: while (_iterator__ex2g4s.q1()) {
            var e = _iterator__ex2g4s.r1();
            if (skip > 0) {
              skip = skip - 1 | 0;
              continue $l$loop;
            }
            buffer.i2(e);
            if (buffer.q2() === this.hm_1) {
              yield* $this$iterator.bl(buffer, $completion);
              if (this.km_1) {
                buffer.a5();
              } else
                buffer = ArrayList().h2(this.hm_1);
              skip = gap;
            }
          }
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!buffer.n1()) {
            if (this.lm_1 || buffer.q2() === this.hm_1)
              yield* $this$iterator.bl(buffer, $completion);
          }
        } else {
          var buffer_0 = RingBuffer().cm(bufferInitialCapacity);
          // Inline function 'kotlin.collections.iterator' call
          var _iterator__ex2g4s_0 = this.jm_1;
          $l$loop_0: while (_iterator__ex2g4s_0.q1()) {
            var e_0 = _iterator__ex2g4s_0.r1();
            buffer_0.fm(e_0);
            if (buffer_0.dm()) {
              if (buffer_0.am_1 < this.hm_1) {
                buffer_0 = buffer_0.em(this.hm_1);
                continue $l$loop_0;
              }
              yield* $this$iterator.bl(this.km_1 ? buffer_0 : ArrayList().j2(buffer_0), $completion);
              buffer_0.gm(this.im_1);
            }
          }
          if (this.lm_1) {
            while (buffer_0.am_1 > this.im_1) {
              yield* $this$iterator.bl(this.km_1 ? buffer_0 : ArrayList().j2(buffer_0), $completion);
              buffer_0.gm(this.im_1);
            }
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!buffer_0.n1())
              yield* $this$iterator.bl(buffer_0, $completion);
          }
        }
        return Unit_instance;
      }
      od(p1, $completion) {
        return this.mm(p1 instanceof SequenceScope() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    windowedIterator$slambdaClass = $;
  }
  return windowedIterator$slambdaClass;
}
function windowedIterator$slambda_0($size, $step, $iterator, $reuseBuffer, $partialWindows) {
  var i = new (windowedIterator$slambda())($size, $step, $iterator, $reuseBuffer, $partialWindows);
  var l = ($this$iterator, $completion) => i.mm($this$iterator, $completion);
  l.$arity = 1;
  return l;
}
//region block: exports
export {
  checkWindowSizeStep as checkWindowSizeStepcg5bise2nnst,
  windowedIterator as windowedIterator1l52d653czu3r,
};
//endregion

//# sourceMappingURL=SlidingWindow.mjs.map
